import styled from 'styled-components'
import React, { useEffect, useRef } from 'react'
import USTemplateDefault from 'src/components/template/us'
import { leagueIds, sportIds, teamShortNames } from 'src/constants/personalizationIds'
import { videos } from 'src/constants/videos'
import { useCountdownTest } from 'src/modules/hooks/useCountdownTest'
import { useSelector } from 'react-redux'
import { selectAnalyticsReady } from 'src/modules/reducers/analytics'
import { selectStateForProtobuf } from 'src/modules/reducers'
import { fireUIRenderEvent } from 'src/modules/analytics/v3'

export default (props) => {
  const { title, subtitle } = props
  const isEventSent = useRef(false)
  const stateForProtobuf = useSelector(selectStateForProtobuf)
  const isAnalyticsReady = useSelector(selectAnalyticsReady)
  const teamId = props?.teamId ? String(props.teamId) : null

  const { matchCountdownTimer, matchTitle, teamMatches } = useCountdownTest(teamId, null, true)

  let teamTitle

  if (props.team) {
    teamTitle = `Watch ${teamShortNames[props.teamId] || props.team} college football live`
  }

  useEffect(() => {
    if (!isEventSent.current && isAnalyticsReady && teamMatches.length) {
      fireUIRenderEvent(
        {
          component: 'countdown_timer_has_game',
        },
        stateForProtobuf
      )
      isEventSent.current = true
    }
  }, [isAnalyticsReady, teamMatches.length])

  return (
    <StyledContainer>
      <USTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        video={props.poster ? null : videos.cfb.videoUrl}
        title={matchTitle || teamTitle || title || 'Watch college football without cable'}
        countdownTimer={matchCountdownTimer}
        subtitle={
          matchTitle
            ? null
            : subtitle || 'Stream Big Ten, CBS, ACC, SEC, ESPN and 200+ live channels'
        }
        networkSet={'collegeFootball'}
        // teams
        team={props.team}
        matchtickerSportId="111"
        matchtickerLeagueName="College Football"
        matchtickerLeagueId="191261"
        showRedzone={false}
        sportId={sportIds.Football}
        leagueId={leagueIds['NCAA Football']}
        {...props}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 800px;
  }
`
